import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ProtectedRoute, { PublicOnlyRoute } from "./components/auth/ProtectedRoute";
import AppLayout from "./components/layout/AppLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import CustomersPage from "./pages/customers/CustomersPage";
import CustomerDetailPage from "./pages/customers/CustomerDetailPage";
import CustomerProductsPage from "./pages/customerProducts/CustomerProductsPage";
import RenewalsPage from "./pages/customerProducts/RenewalsPage";
import ProductsPage from "./pages/products/ProductsPage";
import CategoriesPage from "./pages/masters/CategoriesPage";
import ManufacturersPage from "./pages/masters/ManufacturersPage";
import DeviceTypesPage from "./pages/masters/DeviceTypesPage";
import SubscriptionPlansPage from "./pages/masters/SubscriptionPlansPage";
import UsersPage from "./pages/users/UsersPage";

function App() {
    return (
        <BrowserRouter>
            <ToastProvider>
                <AuthProvider>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <PublicOnlyRoute>
                                    <Login />
                                </PublicOnlyRoute>
                            }
                        />

                        {/* Old public register page: users are now managed at /users (SUPERADMIN only) */}
                        <Route path="/register" element={<Navigate to="/users" replace />} />

                        {/* Any logged-in user */}
                        <Route element={<ProtectedRoute />}>
                            <Route element={<AppLayout />}>
                                <Route path="/profile" element={<Profile />} />

                                {/* SUPERADMIN + RESELLER */}
                                <Route element={<ProtectedRoute roles={["SUPERADMIN", "RESELLER"]} />}>
                                    <Route path="/dashboard" element={<Dashboard />} />
                                    <Route path="/customers" element={<CustomersPage />} />
                                    <Route path="/customers/:id" element={<CustomerDetailPage />} />
                                    <Route path="/customer-products" element={<CustomerProductsPage />} />
                                    <Route path="/renewals" element={<RenewalsPage />} />
                                </Route>

                                {/* SUPERADMIN only */}
                                <Route element={<ProtectedRoute roles={["SUPERADMIN"]} />}>
                                    <Route path="/products" element={<ProductsPage />} />
                                    <Route path="/settings/categories" element={<CategoriesPage />} />
                                    <Route path="/settings/manufacturers" element={<ManufacturersPage />} />
                                    <Route path="/settings/device-types" element={<DeviceTypesPage />} />
                                    <Route path="/settings/plans" element={<SubscriptionPlansPage />} />
                                    <Route path="/users" element={<UsersPage />} />
                                    <Route path="/users/new" element={<Navigate to="/users" replace />} />
                                </Route>

                                <Route path="*" element={<NotFound />} />
                            </Route>
                        </Route>
                    </Routes>
                </AuthProvider>
            </ToastProvider>
        </BrowserRouter>
    );
}

export default App;